import { render, staticRenderFns } from "./nature.vue?vue&type=template&id=7d17cf1b&scoped=true&"
import script from "./nature.vue?vue&type=script&lang=js&"
export * from "./nature.vue?vue&type=script&lang=js&"
import style0 from "./nature.vue?vue&type=style&index=0&id=7d17cf1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d17cf1b",
  null
  
)

export default component.exports